export type SystemRole = 'staff' | 'admin' | 'superadmin';

export const ROLE_ORDER: Record<SystemRole, number> = {
  staff: 1,
  admin: 2,
  superadmin: 3,
};

/**
 * canAccess — true iff userRole >= minRole in the role hierarchy.
 * Defensive: returns false for unknown role strings to avoid silent
 * elevation when an upstream session blob is malformed.
 */
export function canAccess(userRole: SystemRole, minRole: SystemRole): boolean {
  const userLevel = ROLE_ORDER[userRole];
  const minLevel = ROLE_ORDER[minRole];
  if (typeof userLevel !== 'number' || typeof minLevel !== 'number') return false;
  return userLevel >= minLevel;
}
